<template>
  <nav class="customer_nav" v-if="$route.meta.footer">
    <div class="inner">
      <button
        :class="'main' === $route.meta.footerMain ? 'on' : ''"
        @click="handleMain"
      >
        HOME
      </button>
      <button
        :class="'estimate' === $route.meta.footerMain ? 'on' : ''"
        @click="handleEstimate"
      >
        견적수신
        <div class="icon_new" v-if="icRequestNew || mRequestNew"></div>
      </button>
      <button
        :class="'apply' === $route.meta.footerMain ? 'on' : ''"
        @click="handleApply"
      >
        신청현황
      </button>
      <button
        :class="'chat' === $route.meta.footerMain ? 'on' : ''"
        @click="handleChat"
      >
        상담내역
        <div class="icon_new" v-if="chatNew"></div>
      </button>
      <button
        :class="'shop' === $route.meta.footerMain ? 'on' : ''"
        @click="handleShops"
      >
        동네매장
      </button>
    </div>
    <!-- <div class="inner customer_pagefooter">
      <button
        :class="'main' === $route.meta.footerMain ? 'on' : ''"
        @click="handleMain"
      >
        <i class="i_nav_home"></i>홈
      </button>
      <button
        :class="'shop' === $route.meta.footerMain ? 'on' : ''"
        @click="handleShops"
      >
        <i class="i_nav_find"></i>동네매장
      </button>
      <button
        :class="'community' === $route.meta.footerMain ? 'on' : ''"
        @click="handleCommunity"
      >
        <i class="i_nav_apply"></i>커뮤니티
      </button>
      <button
        :class="'chat' === $route.meta.footerMain ? 'on' : ''"
        @click="handleChat"
      >
        <i class="i_nav_chat"></i>상담내역
        <div class="icon_new" v-if="chatNew">
          <i class="i_new"></i>
        </div>
      </button>
      <button
        :class="'estimate' === $route.meta.footerMain ? 'on' : ''"
        @click="handleEstimate"
      >
        <i class="i_nav_estimate"></i>견적수신함
        <div class="icon_new" v-if="icRequestNew || mRequestNew">
          <i class="i_new"></i>
        </div>
      </button> -->
    <!-- <button
        :class="'mypage' === $route.meta.footerMain ? 'on' : ''"
        @click="handleMyPage"
      >
        <i class="i_nav_my"></i>마이페이지
      </button> -->
    <!-- </div> -->
  </nav>
</template>

<script>
export default {
  props: {
    chatNew: Boolean,
    icRequestNew: Boolean,
    mRequestNew: Boolean,
  },
  data(props) {
    return {
      target: '',
    };
  },
  mounted() {},
  methods: {
    handleMain() {
      this.$emit('main-icon-click');
      //this.target = 'main';
    },
    handleShops() {
      this.$emit('shops-icon-click');
      //this.target = 'shops';
    },
    handleCommunity() {
      this.$emit('community-icon-click');
      //this.target = 'shops';
    },
    handleChat() {
      this.$emit('chat-icon-click');
      //this.target = 'chat';
    },
    handleMyPage: function() {
      this.$emit('mypage-icon-click');
      //this.target = 'mypage';
    },
    handleApply: function() {
      this.$emit('apply-icon-click');
      //this.target = 'mypage';
    },
    handleEstimate: function() {
      this.$emit('estimate-icon-click');
      //this.target = 'mypage';
    },
  },
};
</script>
<style scoped></style>
